'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.omittedProps = undefined;

var _datetime = require('helpers/datetime');

exports.default = {
  dateFormat: _datetime.dateFormat.date,
  timeFormat: false,
  closeOnSelect: true,
  inputProps: { className: 'dateTimeInput' },
  isValidDate: function isValidDate(current) {
    return current.isBefore();
  }
};
var omittedProps = exports.omittedProps = ['onChange', 'className', 'autoFocus', 'autoFocusEndDate', 'initialStartDate', 'initialEndDate', 'onOutsideClick'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DateRangePickerWrapper/date-picker-props.js
// module id = 1985
// module chunks = 1